import React, { ReactElement } from "react";
import { ActionIcon, CopyButton, Group, Text, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy, IconExternalLink } from "@tabler/icons-react";
import styles from "./CopyText.module.scss";
import { useNavigate } from "react-router-dom";

export default function CopyTextComponent({
  text,
  value = text, //If value is not supplied display text is the same as value
  size = "1rem",
  weight = "400",
  align = "apart",
  iconBackgroundColor = "transparent",
  iconColor = "var(--mid-dark)",
  primaryColor = true,
  link = "",
  gap = "5",
}: {
  text: string;
  value?: string;
  size?: string;
  weight?: string;
  align?: string;
  iconBackgroundColor?: string;
  iconColor?: string;
  primaryColor?: boolean;
  link?: string;
  gap?: string;
}): ReactElement | null {
  const navigate = useNavigate();
  function isExternalLink(link: string): boolean {
    return link.startsWith("http");
  }
  const openLink = () => {
    if (link) {
      if (isExternalLink(link)) {
        window.open(link, "_blank");
      } else {
        navigate(link);
      }
    }
  };
  return (
    <>
      <CopyButton value={value} timeout={3000}>
        {({ copied, copy }) => (
          <Group
            wrap={"nowrap"}
            justify={align}
            w={"fit-content"}
            maw={"100%"}
            gap={gap}
          >
            <span
              style={{
                fontSize: `calc(${size} * $scale)`,
                fontWeight: weight,
                lineHeight: `calc(${size} * 1.15)`,
              }}
              onClick={link ? openLink : copy}
              className={`${styles.copyText} ${primaryColor ? styles.primary : ""} ${link ? styles.copyTextLink : ""}`}
              // me={5}
            >
              {text}
            </span>
            <Tooltip
              label={copied ? "Copied" : "Copy"}
              withArrow
              position="right"
            >
              <ActionIcon
                c={copied ? "teal" : iconColor}
                className={styles.actionIcon}
                style={{
                  background: iconBackgroundColor,
                  width: size,
                }}
                onClick={copy}
              >
                {copied ? (
                  <IconCheck size={`calc(${size} * 0.9) `} />
                ) : (
                  <IconCopy size={`calc(${size} * 0.9) `} />
                )}
              </ActionIcon>
            </Tooltip>
            {isExternalLink(link) && (
              <ActionIcon
                c={iconColor}
                className={styles.actionIcon}
                style={{
                  background: iconBackgroundColor,
                  width: size,
                }}
                onClick={() => openLink()}
              >
                <IconExternalLink size={`calc(${size} * 0.9) `} />
              </ActionIcon>
            )}
          </Group>
        )}
      </CopyButton>
    </>
  );
}
